// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyRflgBuXabCRc_DrBAj {
  max-height: 26px;
  overflow-y: auto;
}

.gyRflgBuXabCRc_DrBAj::-webkit-scrollbar {
  -webkit-appearance: none;
}

.gyRflgBuXabCRc_DrBAj::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border: 2px solid white;
  border-radius: 8px;
}

.gyRflgBuXabCRc_DrBAj::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}

.gyRflgBuXabCRc_DrBAj::-webkit-scrollbar:vertical {
  width: 11px;
}

.mnQu_gh4qkdHmmVhHegw {
  margin: 2px 4px 2px 0 !important;
}

.yzqUDriQtn7AUDJRowjZ {
  margin-top: 8px !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/organisations/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oCAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,0BAAA;AACF","sourcesContent":[".tag_wrapper {\n  max-height: 26px;\n  overflow-y: auto;\n}\n\n.tag_wrapper::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.tag_wrapper::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.5);\n  border: 2px solid white;\n  border-radius: 8px;\n}\n\n.tag_wrapper::-webkit-scrollbar-track {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.tag_wrapper::-webkit-scrollbar:vertical {\n  width: 11px;\n}\n\n.tag {\n  margin: 2px 4px 2px 0 !important;\n}\n\n.article_tag {\n  margin-top: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag_wrapper": `gyRflgBuXabCRc_DrBAj`,
	"tag": `mnQu_gh4qkdHmmVhHegw`,
	"article_tag": `yzqUDriQtn7AUDJRowjZ`
};
export default ___CSS_LOADER_EXPORT___;
